import {http} from '@/axios'

export default function ({messenger}) {
  return http.post('/api/new-vacancy/bookmarks/mass-sent', {
    messanger: messenger
  })
}
